import { SelectedFilter } from "../../Shared/scriptts/interfaces";
import { isEmpty } from '../../Shared/scriptts/utilities';
import { params, aliasMapping, cyberWorkRoles, executeSearchUrl, displayResults } from '../search-main';
import { isBrandedSearchFilter, setFilterCount, removeParam, getPreferenceToggle, getNormalizedFilterName } from '../search-filters-main';

const filterPills = document.querySelector<HTMLElement>('#filter-pills');

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLButtonElement>('#remove-filters, #remove-filters_m').forEach(elem => elem.addEventListener('click', removeAllClicked));
});

/**
 * Display pills for filters that have been applied to the search
 */
export function displayFilterPills() {
    if (!filterPills) {
        return 0;
    }
    filterPills.innerHTML = '';

    let filterCount = buildFilterPills() + buildNonSelectableFilterPills();

    if (params.GradeSearch || !isEmpty(params.RemunerationMinimumAmount)) {
       filterCount += buildPayPills();
    }

    if (filterCount > 0) {
        document.querySelector<HTMLElement>('#filter-pills-container')?.classList.remove('hidden');

        if (document.querySelectorAll<HTMLButtonElement>('[data-filter]').length < 1) {
            document.querySelector<HTMLButtonElement>('#remove-filters')?.classList.add('hidden');
        }
        else {
            document.querySelector<HTMLButtonElement>('#remove-filters')?.classList.remove('hidden');
        }
    }
    else {
        document.querySelector<HTMLElement>('#filter-pills-container')?.classList.add('hidden');
    }

    setFilterCount(filterCount);
}

function buildFilterPills(): number {
    if (!filterPills) {
        return 0;
    }
    const searchFilters = document.querySelector<HTMLElement>('#search-filters');
    if (!searchFilters) {
        return 0;
    }

    let count = 0;
    searchFilters.querySelectorAll<HTMLInputElement>('input').forEach(elem => {
        if (elem.name === 'radius' || elem.name === 'sort-item') {
            return;
        }
        if (elem.checked) {
            const itemFilterType = elem.dataset.filterType || elem.name;
            const filter: SelectedFilter = {
                Name: getNormalizedFilterName(document.querySelector<HTMLLabelElement>(`[for=${elem.id}]`)?.innerText || '', elem.id),
                Value: elem.value,
                FilterType: itemFilterType,
                IsBrandedSearch: isBrandedSearchFilter(itemFilterType, elem.value)
            }
            filterPills.appendChild(getFilterPill(filter));
            ++count;
        }
    });
    return count;
}

function buildPayPills(): number {
    if (!filterPills || (!params.GradeSearch && isEmpty(params.RemunerationMinimumAmount))) {
        return 0;
    }
    let count = 0;
    if (params.GradeSearch && Array.isArray(params.GradeBucket) && params.GradeBucket.length > 0) {
        const pillName = `GS ${params.GradeBucket[0]} - GS ${params.GradeBucket[params.GradeBucket.length - 1]}`;
        const filter: SelectedFilter = {
            Name: pillName,
            Value: pillName,
            FilterType: 'GradeBucket',
            IsBrandedSearch: isBrandedSearchFilter('GradeBucket', params.GradeBucket[0])
        }
        filterPills.appendChild(getFilterPill(filter));
        ++count;
    }
    else if (!params.GradeSearch && !isEmpty(params.RemunerationMinimumAmount) && !isEmpty(params.RemunerationMaximumAmount)) {
        const pillName = `${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(parseInt(params.RemunerationMinimumAmount || '0')).toString()} - ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(parseInt(params.RemunerationMaximumAmount || '0')).toString()}`;
        const filter: SelectedFilter = {
            Name: pillName,
            Value: pillName,
            FilterType: 'RemunerationMinimumAmount',
            IsBrandedSearch: isBrandedSearchFilter('RemunerationMinimumAmount', (params.RemunerationMinimumAmount || '')) && isBrandedSearchFilter('RemunerationMaximumAmount', (params.RemunerationMaximumAmount || ''))
        }
        filterPills.appendChild(getFilterPill(filter));
        ++count;
    }
    else if (!params.GradeSearch && !isEmpty(params.RemunerationMinimumAmount)) {
        const pillName = `${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(parseInt(params.RemunerationMinimumAmount || '0')).toString()} (Minimum salary)`;
        const filter: SelectedFilter = {
            Name: pillName,
            Value: pillName,
            FilterType: 'RemunerationMinimumAmount',
            IsBrandedSearch: isBrandedSearchFilter('RemunerationMinimumAmount', (params.RemunerationMinimumAmount || ''))
        }
        filterPills.appendChild(getFilterPill(filter));
        ++count;
    }
    return count;
}

function buildNonSelectableFilterPills(): number {
    if (!filterPills) {
        return 0;
    }

    const nonSelectableFilterParams = [
        'LocationName',
        'SocTitle',
        'CyberWorkRole',
        'JobTitle',
        'JobGradeCode'
    ];
    let count = 0;

    nonSelectableFilterParams.forEach(param => {
        const paramValue = params[param];

        if (!paramValue) {
            return;
        }
        if (Array.isArray(paramValue)) {
            paramValue.forEach(val => {
                let name = val;
                if (param === 'JobGradeCode') {
                    name += ' (Pay plan)';
                }
                else if (param === 'CyberWorkRole') {
                    name = cyberWorkRoles[val];
                }
                const filter: SelectedFilter = {
                    Name: name,
                    Value: val,
                    FilterType: aliasMapping[param].ElasticName,
                    IsBrandedSearch: isBrandedSearchFilter(aliasMapping[param].ElasticName, val)
                };
                filterPills.appendChild(getFilterPill(filter));
                ++count;
            });
            if (param === 'LocationName' && paramValue.length > 0) {
                const radiusElem = document.querySelector<HTMLInputElement>('[name=radius]');                
                if (!radiusElem || document.querySelector<HTMLElement>('#radius-filter')?.classList.contains('hidden')) {
                    return;
                }
                const filter: SelectedFilter = {
                    Name: getNormalizedFilterName(`${radiusElem.value} miles`, radiusElem.id),
                    Value: radiusElem.value,
                    FilterType: radiusElem.name,
                    IsBrandedSearch: isBrandedSearchFilter(radiusElem.name, radiusElem.value)
                };
                filterPills.appendChild(getFilterPill(filter));
                ++count;    
            }
        }
        else {
            const filter: SelectedFilter = {
                Name: paramValue,
                Value: paramValue,
                FilterType: aliasMapping[param].ElasticName,
                IsBrandedSearch: isBrandedSearchFilter(aliasMapping[param].ElasticName, paramValue)
            };
        }
    });
    return count;
}

function getFilterPill(filter: SelectedFilter): HTMLDivElement {
    const bgColor = filter.IsBrandedSearch ? 'bg-primary-darker' : 'bg-gray-dark';
    const textColor = 'text-white';
    const fillColor = 'fill-white';
    const container = document.createElement('div');

    container.className = `font-semibold rounded flex flex-nowrap gap-2 justify-between text-xs px-2 py-1 mb-2 ${bgColor} ${textColor}`;
    container.innerHTML = `<span class="whitespace-nowrap">${filter.Name}</span>`;

    if (!filter.IsBrandedSearch) {
        const closeButton = document.createElement('button');

        closeButton.className = 'cursor-pointer';
        closeButton.id = `close-${Math.round(Math.random() * 10000)}`;
        closeButton.setAttribute('data-filter', filter.FilterType);
        closeButton.setAttribute('data-filter-name', filter.Name);
        closeButton.setAttribute('data-filter-value', filter.Value);
        closeButton.setAttribute('title', `Remove ${filter.Name} filter`);
        closeButton.innerHTML = `<svg class="w-4 h-4 pointer-events-none ${fillColor}" role="presentation"><use xlink:href="/img/icons/sprite.svg#close"></use></svg>`;
        closeButton.addEventListener('click', closeButtonClicked);
        container.appendChild(closeButton);
    }

    return container;
}

function closeButtonClicked(evt: Event) {
    const elem = <HTMLButtonElement>(evt.target);

    removeParam(aliasMapping[elem.getAttribute('data-filter') || '']?.JOAQueryName || '', elem.getAttribute('data-filter-value') || '');

    if (getPreferenceToggle()) {
        let userPrefsFound = false;
        const closeButtons = document.querySelectorAll<HTMLButtonElement>('[data-filter]');
        
        for (const i in closeButtons) {
            const button = closeButtons[i];            
            if (!button || isNaN(parseInt(i)) || (elem.id == button.id)) {
                continue;
            }

            const filterType = aliasMapping[button?.getAttribute('data-filter') || '']?.JOAQueryName || '';
            const filterValue = button?.getAttribute('data-filter-value') || '';
        }
    }

    displayResults(executeSearchUrl, false, true);
}

function removeAllClicked() {
    document.querySelectorAll<HTMLButtonElement>('[data-filter]').forEach(elem => {
        const param = aliasMapping[elem.getAttribute('data-filter') || '']?.JOAQueryName || '';
        const value = elem.getAttribute('data-filter-value') || '';

        if (!isBrandedSearchFilter(param, value)) {
            removeParam(param, value);
        }
    });
    
    displayResults(executeSearchUrl, false, true);
}
